<template>
  <div
    v-overlay.autofocus="isSafari ? null : close"
    class="bg-black/[.45] fixed top-0 left-0 h-full w-full min-h-[100vh] z-[998]"
    data-test="flyout-overlay"
    @mousedown="close"
    @keyup.escape="close"
  >
    <div class="fixed top-0 right-0 flex w-full h-screen md:flex-col z-[999] sm:w-96" @mousedown.stop>
      <div class="relative flex flex-col w-full h-full overflow-hidden bg-white">
        <div class="absolute flex flex-row cursor-pointer top-4 right-4" data-test="close-flyout" @keyup.enter="close">
          <CIcon tabindex="0" name="close" size="medium" class="mb-1 z-[1000] text-gray-800" @click="close" />
        </div>

        <header v-if="hasHeaderSlot" class="p-4 md:p-6">
          <slot name="header"></slot>
        </header>

        <main class="h-full overflow-auto bg-gray-100 no-scrollbar">
          <slot name="body"></slot>
        </main>

        <footer
          v-if="hasFooterSlot"
          class="box-border sticky bottom-0 right-0 w-full p-6 text-xs text-gray-800 bg-gray-100"
        >
          <slot name="footer"></slot>
        </footer>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
const emit = defineEmits<{ (e: 'close'): void }>();

const { isSafari } = useBrowserDetection();

const close = () => {
  emit('close');
};

const props = withDefaults(defineProps<{ slots: any }>(), { slots: {} });

const hasHeaderSlot = computed(() => !!props.slots.header);
const hasFooterSlot = computed(() => !!props.slots.footer);

onMounted(() => {
  document.getElementsByTagName('body')[0].classList.add('overflow-hidden');
});
onBeforeUnmount(() => {
  document.getElementsByTagName('body')[0].classList.remove('overflow-hidden');
});
</script>

<script lang="ts">
export default defineComponent({
  name: 'FlyoutComponent',
});
</script>
